import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const baseQuery = fetchBaseQuery({
    baseUrl: '/api',
    credentials: 'include',
    headers: {
        'Content-Type': 'application/json',
    },
});
